import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { useSelector } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import { store } from './redux/store';
import { SocketProvider } from './context/SocketContext';
import { ModalProvider } from './context/ModalContext';
import ErrorBoundary from './components/ErrorBoundary';
import HoverGradientNavBar from './components/ui/hover-gradient-nav-bar';
import ProtectedRoute from './components/ProtectedRoute';
import DefaultRedirect from './components/DefaultRedirect';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import UserList from './pages/UserList';
import UserDetail from './pages/UserDetail';
import UserRoles from './pages/UserRoles';
import CampaignList from './pages/CampaignList';
import CampaignDetail from './pages/CampaignDetail';
import CampaignTemplates from './pages/CampaignTemplates';
import NotificationManagement from './pages/NotificationManagement';
import UserRatings from './pages/UserRatings';
import AllCampaigns from './pages/AllCampaigns';
import Payments from './pages/Payments';

function ProtectedLayout({ children }) {
  return (
    <ModalProvider>
      <div className="flex min-h-screen flex-col bg-background">
        <div className="flex-1 w-full pb-16 md:pb-20">
          <div className="p-4 md:p-5 max-w-[1400px] mx-auto">
            {children}
          </div>
        </div>
        <HoverGradientNavBar />
      </div>
    </ModalProvider>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <SocketProvider>
          <Router>
            <Toaster position="top-right" />
            <Routes>
            {/* Login sayfası - Public */}
            <Route path="/login" element={<Login />} />

            {/* Protected Routes - Sidebar ile */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <ProtectedLayout>
                    <DefaultRedirect />
                  </ProtectedLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <ProtectedLayout>
                    <Dashboard />
                  </ProtectedLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/odemeler"
              element={
                <ProtectedRoute>
                  <ProtectedLayout>
                    <Payments />
                  </ProtectedLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/kullanicilar"
              element={
                <ProtectedRoute>
                  <ProtectedLayout>
                    <UserList />
                  </ProtectedLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/kullanicilar/:id"
              element={
                <ProtectedRoute>
                  <ProtectedLayout>
                    <UserDetail />
                  </ProtectedLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/kullanici-rolleri"
              element={
                <ProtectedRoute>
                  <ProtectedLayout>
                    <UserRoles />
                  </ProtectedLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/campaigns/all"
              element={
                <ProtectedRoute>
                  <ProtectedLayout>
                    <AllCampaigns />
                  </ProtectedLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/kampanyalar"
              element={
                <ProtectedRoute>
                  <ProtectedLayout>
                    <Navigate to="/kampanyalar/genel" replace />
                  </ProtectedLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/kampanyalar/bana-ozel"
              element={
                <ProtectedRoute>
                  <ProtectedLayout>
                    <CampaignList type="personal" />
                  </ProtectedLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/kampanyalar/genel"
              element={
                <ProtectedRoute>
                  <ProtectedLayout>
                    <CampaignList type="general" />
                  </ProtectedLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/kampanyalar/taslaklar"
              element={
                <ProtectedRoute>
                  <ProtectedLayout>
                    <CampaignTemplates />
                  </ProtectedLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/kampanyalar/detay/:id"
              element={
                <ProtectedRoute>
                  <ProtectedLayout>
                    <CampaignDetail />
                  </ProtectedLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/bildirimler"
              element={
                <ProtectedRoute>
                  <ProtectedLayout>
                    <NotificationManagement />
                  </ProtectedLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/kullanici-yorumlari"
              element={
                <ProtectedRoute>
                  <ProtectedLayout>
                    <UserRatings />
                  </ProtectedLayout>
                </ProtectedRoute>
              }
            />
            {/* 404 - Tüm bilinmeyen route'lar için */}
            <Route
              path="*"
              element={
                <ProtectedRoute>
                  <ProtectedLayout>
                    <Navigate to="/dashboard" replace />
                  </ProtectedLayout>
                </ProtectedRoute>
              }
            />
            </Routes>
          </Router>
        </SocketProvider>
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
